import { Vehicle, VehicleFilter } from '../shared/domain';

export interface WatchlistStoreData {
    isLoading?: boolean;
    error?: object;
    vehicles: Vehicle [];
    aggregations?: VehicleFilter[];
    total?: number;
    autoRefresh?: boolean;
}

export const WATCHLIST_INITIAL_STORE_DATA: WatchlistStoreData = {
    isLoading   : true,
    vehicles    : [],
    aggregations: [],
    autoRefresh : false
};



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/watchlist-store-data.ts